import { sum } from 'lodash';
import { each, removeChildren } from '../../lib/util';
import WidgetBase from '../widget.base';

export default class KidsBirthdayClubForm extends WidgetBase {
    static selector = '[data-ww-kids-birthday-club-form]';
    static FieldsetFieldsSelector = "input:not([type='hidden'])";
    static HideCssClass = "hide";
    formSelector = 'form';

    constructor(el) {
        super(el);
        this.form = this.el.querySelector(this.formSelector);

        const elementsToHide = this.el.querySelectorAll("fieldset[data-child-information]:not([data-child-information = '0'])");
        each(elementsToHide, (fieldset) => {
            const inputs = Array.from(fieldset.querySelectorAll(KidsBirthdayClubForm.FieldsetFieldsSelector));
            const hasNoValues = inputs.every(x => typeof (x.value) === 'undefined' || x.value.length === 0);

            if (hasNoValues) {
                fieldset.classList.add(KidsBirthdayClubForm.HideCssClass);
            }
        });

        this.initEvents();

        setTimeout(() => {
            this.loaded();
        });
    }

    handleSuccess = () => {
        document.getElementById('blank-form').style.display = 'none';
        let template = document.querySelector('#thank-you');
        document.querySelector('.form-widget').appendChild(template.content.cloneNode(true));
    };
    resetErrors = () => {
        const fields = this.form.querySelectorAll('.formulate__field--validation-error');

        each(fields, (field) => {
            field.classList.remove('formulate__field--validation-error');

            const summary = field.querySelector('.formulate__inline-validation-summary');
            if (summary === null) {
                return;
            }

            removeChildren(summary);
        });
    }

    createErrorSummary = (parent) => {
        const element = document.createElement('ul');
        element.classList.add('formulate__inline-validation-summary');
        parent.appendChild(element);

        return element;
    }

    handleErrors = (errors) => {
        this.resetErrors();

        for (const [key, value] of Object.entries(errors)) {
            const input = this.form.querySelector(`[name='${key}']`);
            const field = input.closest('.formulate__field');

            if (field === null) {
                continue;
            }

            field.classList.add('formulate__field--validation-error');

            let summary = field.querySelector('.formulate__inline-validation-summary');

            if (summary === null) {
                summary = this.createErrorSummary(field);
            }

            value.forEach((error) => {
                const element = document.createElement('li');
                element.innerText = error;

                summary.appendChild(element);
            });
        }
    };


    initEvents = () => {
        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            let formElement = e.currentTarget;
            formElement.querySelector('#receive-updates').value = formElement.querySelector('#receive-updates').value === 'on' ? true : false;
            const hiddenFieldsets = formElement.querySelectorAll('[data-child-information].hide');

            let data = new FormData(e.target);

            hiddenFieldsets.forEach(x => {
                const { childInformation: index } = x.dataset;

                if (index === '0') {
                    return;
                }

                data.delete(`ChildInformation[${index}].FirstName`);
                data.delete(`ChildInformation[${index}].LastName`);
                data.delete(`ChildInformation[${index}].BirthDate`);
            });

            let response = await fetch(e.target.action, {
                method: "POST",
                body: data,
            });
            const result = await response.json();
            const { success, errors } = result;

            if (success === true) {
                this.handleSuccess();
            }
            else {
                this.handleErrors(errors);
            }
        });

        this.form.querySelector('button[data-add-child-btn]').addEventListener('click', function (e) {
            e.preventDefault();
            const nextChildEl = document.querySelector("[data-child-information].hide");

            if (nextChildEl === null) {
                return;
            }

            nextChildEl.classList.remove("hide");
        });

        this.form.querySelector('button[data-remove-child-btn]').addEventListener('click', function (e) {
            e.preventDefault();

            const lastVisibleChildEl = document.querySelector(":nth-last-child(1 of [data-child-information]:not(.hide))");

            if (lastVisibleChildEl === null) {
                return;
            }

            const { childInformation: index } = lastVisibleChildEl.dataset;

            if (index === "0") {
                return;
            }

            lastVisibleChildEl.classList.add("hide");

            const inputs = Array.from(lastVisibleChildEl.querySelectorAll(KidsBirthdayClubForm.fieldsetFieldsSelector));
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].value = '';
            }

        });
    }
}